// third-party

import { NavItemType } from "types";

import * as RouteHelper from "@utils/routes";

import SummarizeIcon from "@mui/icons-material/Summarize";
import TrackChanges from "@mui/icons-material/TrackChanges";
import { useTheme } from "@mui/material";
import GroupIcon from "@mui/icons-material/Group";
import BallotIcon from "@mui/icons-material/Ballot";
// ==============================|| APPLICATION MENU ITEMS ||============================== //

export const getAnalysisNav = (projectId: string): NavItemType => {
  const theme = useTheme();
  return {
    id: "analytics",
    title: "Reporting", //TODO: change class to reporting
    icon: <TrackChanges sx={{ color: theme.palette.primary.main }} />,
    type: "group",
    children: [
      {
        id: "report",
        title: "Monthly Reporting",
        type: "item",
        icon: <SummarizeIcon sx={{ color: theme.palette.primary.main }} />,
        url: RouteHelper.contractorReports(projectId),
      },
      {
        id: "employees",
        title: "Employees",
        type: "item",
        icon: <GroupIcon sx={{ color: theme.palette.primary.main }} />,
        url: RouteHelper.contractorEmployees(projectId),
      },
      {
        id: "policies",
        title: "Policies",
        type: "item",
        icon: <BallotIcon sx={{ color: theme.palette.primary.main }} />,
        url: RouteHelper.contractorPolicies(projectId),
      },
    ],
  };
};
